import React from "react";
import { connect } from "react-redux";
import {
    clearCampaignAggCache,
    clearCampaignCanvassersCache,
    clearCampaignOfficeCache,
    clearCampaignSitesCache,
    clearDashboardOptions,
    clearSiteCanvassCache
} from "../../store/actions";
import { withRouter } from "../../utils/withRouter";
import { logout } from "../../allauth/lib/allauth";
import { setFocusedMembership } from "../../store/api/calls";
import { persistor } from "../../store";

class CampaignSelectScreen extends React.Component {

    handleCampaignSelection = (id) => {
        setFocusedMembership(id);
        this.props.history.push("/dash");
    };

    doLogout() {
        // Clear all persisted storage
        persistor.purge();
        
        // Then perform the backend logout
        logout().then(() => {
            window.location.href = "/"; // hard redirect to home
        }).catch((e) => {
            console.error(e);
            window.alert(e);
        });
    }

    componentDidMount() {
        this.props.clearCampaignAggCache();
        this.props.clearDashboardOptions();
        this.props.clearSiteCanvassCache();
        this.props.clearCampaignCanvassersCache();
        this.props.clearCampaignSitesCache();
        this.props.clearCampaignOfficeCache();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.memberships !== this.props.memberships) {
            if (this.props.memberships.length === 1) {
                this.handleCampaignSelection(this.props.memberships[0].campaign.id);
            }
        }
    }

    renderCampaignOptions = () => {
        const memberships = this.props.memberships || [];
        if (memberships.length === 0) {
            return <h3 style={{ color: "white" }}>
                <div
                    className="campaign-option card wox-card"
                    style={{ width: "100%", height: "25vh" }}
                    onClick={() => this.props.history.goBack()}
                >
                    <div
                        className="campaign-name"
                        style={{ fontSize: ".7em", padding: "2em", color: '#202020' }}
                    >
                        You have no campaign memberships. Please ask
                        your admin to adjust your permissions.
                        <br />
                        <br />
                        <b onClick={() => this.doLogout()} >Click this to log out.</b>
                    </div>
                </div>
            </h3>
        }

        return memberships.map(({ campaign, roles }) => {
            return (
                <div
                    className="campaign-option card wox-card"
                    data-campaignid={campaign.id}
                    key={`select-campaign-${campaign.id}`}
                    onClick={() => this.handleCampaignSelection(campaign.id)}
                >
                    <div className="campaign-name no-select">{campaign.name}</div>
                    <small className="campaign-role no-select">{roles.map(role => role.name).join(', ')}</small>
                </div>
            );
        });
    };

    render() {
        return (
            <div className="campaign-select-wrapper metallicFlash">
                <div className="top-logo no-select align-center mb-4">
                    <img
                        src={"/logo-full192.png"}
                        alt={"ElecTrek"}
                        className={"shadow"}
                    />
                </div>
                <div className="campaign-option-container">
                    {this.renderCampaignOptions()}
                </div>
                <div className="campaign-option-footer">&nbsp;</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    memberships: state.permissions.memberships || [],
});

const mapDipatchToProps = (dispatch) => ({
    clearSiteCanvassCache: () => dispatch(clearSiteCanvassCache()),
    clearCampaignCanvassersCache: () => dispatch(clearCampaignCanvassersCache()),
    clearCampaignSitesCache: () => dispatch(clearCampaignSitesCache()),
    clearCampaignOfficeCache: () => dispatch(clearCampaignOfficeCache()),
    clearCampaignAggCache: () => dispatch(clearCampaignAggCache()),
    clearDashboardOptions: () => dispatch(clearDashboardOptions()),
});

export default connect(
    mapStateToProps,
    mapDipatchToProps
)(withRouter(CampaignSelectScreen));
